import { finish, error } from '../../../modules/tags/actions/add-value';
import api from '../../../api';

export function request(dispatch, { tag, value }) {
    api.post('/tags/' + tag + '/values', value).then(
        (data) => dispatch(finish({
            [tag]: data
        })),
        ({ errors }) => dispatch(error(tag, errors))
    );
}
